import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Uppercase 12 px section label with letter-spacing ("LIVE ACTIVITY"). */
export function Kicker({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cn('inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.08em] text-foreground', className)}>{children}</span>;
}
